export default __webpack_public_path__ + "static/decorist-8-d-4234fb796666df89f403c798746dffeb.webp";